import React from "react";
import Button from "components/ui/Button";
import { cn } from "helper/Utils";
import { SkeletonLoader } from "components/ui/loaders/SkeletonLoader";
import { useNavigate } from "react-router-dom";
import { useAuth } from "provider/AuthContext";

export const GameCard = ({ data, searchGamesCard, loading }) => {
  const navigate = useNavigate();
  const { user, handleLoginClick } = useAuth();

  const gameLauncher = (gameId, provider) => {
    navigate(`/game-play/${gameId}${provider ? "?provider=" + provider : ""}`);
  };

  return (
    <>
      <style jsx="true">
        {`
          .game-card .overlay {
            visiblity: none;
          }
          .game-card:hover .overlay,
          .game-card:active .overlay {
            visiblity: visible;
            opacity: 1;
          }
        `}
      </style>
      {loading ? (
        <SkeletonLoader className="aspect-[5/3.5]" />
      ) : (
        <div
          tabIndex="-1"
          className="game-card relative aspect-[5/3.5] bg-[#242424] rounded overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300"
        >
          <img src={data?.image_square} alt={data?.name} className="w-full h-full" />
          <div className="overlay absolute inset-0 gap-2 bg-black bg-opacity-50 backdrop-blur-sm flex flex-col items-center justify-end p-4 opacity-0 transition-opacity">
            <p className="text-white text-sm text-[9.5px] text-center px-4 sm:h-[calc(100%-3.5rem)] h-[calc(100%-2rem)] flex items-center leading-none">
              {data?.name}
            </p>
            <div className={cn("flex gap-2", searchGamesCard ? "w-full" : "")}>
              <Button
                label="Play"
                variant={searchGamesCard ? "pink" : "green"}
                className={cn("p-1", searchGamesCard ? "w-full" : "lg:w-20 w-16")}
                onClick={() => (user ? gameLauncher(data.gameId || data.gameid) : handleLoginClick())}
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
};
